/**
 * Created by Ivan on 15.09.2023
 */

const ReplaceAllBooster = function (id) {
    Booster.call(this, id);
};

ReplaceAllBooster.prototype = Object.create(Booster.prototype);
ReplaceAllBooster.prototype.constructor = ReplaceAllBooster;

ReplaceAllBooster.prototype.isForceAvailable = function () {
    return Booster.prototype.isForceAvailable.call(this) && Game.currentGame.isBoosterForceEnabled();
};

ReplaceAllBooster.prototype.onExecute = function () {
    Game.currentGame.counter.setTimeout(() => {}, 300);
    
    Game.currentGame.applySelectionAlgorithm({
        findSolvable: true,
        findMaxExplode: true,
        proposedIndexes: false,
        callback: function (forms) {
            forms = forms.items.map((solvable) => Forms.ALL_POSSIBLE_VARIANTS[solvable]);

            forms.forEach((form, index) => {
                Game.currentGame.pieces.clearHint(index);
                Game.currentGame.pieces.replacePiece({
                    index,
                    form,
                    color: Game.currentGame.pieces.calcPieceColor()
                });
            });

            Game.currentGame.setTimeout(() => {
                Game.currentGame.checkMoves();
            }, 1200);
        }
    });
};